import { Button, Col, Label } from "reactstrap";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import FormAssessmentIndividu from "../components/FormAssessmentIndividu";
import DetailHeader from "../components/DetailHeader";
import DetailPetunjukUmum from "../components/DetailPetunjukUmum";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import useAxios from "../../../Utils/useAxios";
import getUnitKerja from "../services/getUnitKerja";
import getStaff from "../services/getUser";
import getAsesmenPredikatByList from "../services/getAsesmenPredikatByList";
import getAsesmenIndividuSelf from "../services/getAsesmenIndividuSelf";
import { ASESMEN_TYPE, PetunjukUmumIndividu } from "../constants";

const AssessmentIndividuContain = () => {
  const [data, setData] = useState({
    staf: [],
    unitKerja: [],
    asesmenIndividu: [],
    asesmenPredikat: [],
  });

  const axiosInstance = useAxios();

  useEffect(() => {
    const fetchData = () => {
      getUnitKerja(axiosInstance).then((res) =>
        setData((prev) => ({
          ...prev,
          unitKerja: res.data,
        }))
      );

      getStaff(axiosInstance).then((res) =>
        setData((prev) => ({
          ...prev,
          staf: res.data,
        }))
      );

      getAsesmenIndividuSelf(axiosInstance).then((res) =>
        setData((prev) => ({
          ...prev,
          asesmenIndividu: res.data,
        }))
      );
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (data.asesmenIndividu.length > 0 && data.asesmenIndividu[0]?.predikats)
        getAsesmenPredikatByList(
          axiosInstance,
          data.asesmenIndividu[0]?.predikats
        ).then((res) => {
          setData((prev) => ({ ...prev, asesmenPredikat: res.data }));
        });
    };

    fetchData();
  }, [data.asesmenIndividu]);

  return (
    <FeatureContainer>
      <div className="px-4">
        <Link to={`/dashboard`}>
          <Button>Kembali ke Dashboard</Button>
        </Link>
      </div>
      <Col
        sm={{
          offset: 1,
          size: 10,
        }}
      >
        <Label className={"d-flex justify-content-center h4"}>
          <strong>Formulir Penilaian Kinerja Individu</strong>
        </Label>
        <DetailHeader
          className={"py-4"}
          data={data}
          type={ASESMEN_TYPE.Individu}
        />
        <DetailPetunjukUmum
          colSM={{
            offset: 2,
            size: 8,
          }}
          className={"my-2 pb-4"}
          petunjukUmum={PetunjukUmumIndividu}
        />
        <FormAssessmentIndividu data={data} />
      </Col>
    </FeatureContainer>
  );
};

export default AssessmentIndividuContain;
